const CONNECT = process.env.GATSBY_CONNECT_URL;
const CONNECT_CLIENT = process.env.GATSBY_CONNECT_CLIENT;

const LANGUAGES = process.env.GATSBY_LANGUAGES;
const DEFAULT_LANGUAGE = process.env.GATSBY_DEFAULT_LANGUAGE;

const KEYCARD = process.env.GATSBY_KEYCARD;

export { CONNECT, CONNECT_CLIENT, LANGUAGES, DEFAULT_LANGUAGE, KEYCARD };
